import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';

import { useApi } from '../../../shared/hooks/use-api.hook';
import { WorkUrls } from '../../../shared/utils/api.utils';
import { AppRoutes } from '../../../constants/routes';

import WorkDetails from '../../../components/portfolio/work-details/work-details.component';
import PageLayout from '../../../components/shared/page-layout/page-layout.component';

import { usePVStyles } from './portfolio-view.styles';

const PortfolioView = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const classes = usePVStyles();
  const [getWorks, loadState, works] = useApi({ url: WorkUrls.getWorks });

  useEffect(() => getWorks(), [getWorks]);

  const work = works && works.find((work) => work.slug === slug);

  return (
    <PageLayout hideHeading>
      <Box
        cursor='pointer'
        onClick={() => navigate(AppRoutes.WORKS.route)}
        display='flex'
        alignItems='center'
        color='primary'
        width='100%'
        marginBottom='25px'
      >
        <ChevronLeft fontSize='large' />
        Back
      </Box>
      <Box
        display='flex'
        justifyContent='space-between'
        paddingBottom='170px'
        sx={{
          '@media (max-width: 1024px)': {
            flexDirection: 'column-reverse',
            alignItems: 'center',
          },
        }}
      >
        {work && <WorkDetails work={work} />}
        {work && (
          <Box
            width='60%'
            minWidth='60%'
            height='400px'
            display='flex'
            alignItems='center'
            justifyContent='center'
            borderRadius={3}
            overflow='hidden'
            sx={{
              '@media (max-width: 1024px)': {
                width: '100%',
                marginBottom: '30px',
              },
            }}
          >
            {!work.isYoutubeVideo ? (
              <video className={classes.video} controls>
                <source src={work.video.url} type='video/mp4' />
                <source src={work.video.url} type='video/ogg' />
                Your browser does not support the video tag.
              </video>
            ) : (
              <iframe
                className={classes.video}
                src={work.video.url}
                title={work.title}
              />
            )}
          </Box>
        )}
      </Box>
    </PageLayout>
  );
};

export default PortfolioView;
